function cov_1ltzyrx9n4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp16.tsx";
  var hash = "5d1f19504d5f4f9df48384cb465bacefa7307fff";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp16.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5d1f19504d5f4f9df48384cb465bacefa7307fff"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ltzyrx9n4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ltzyrx9n4();
var Icon = (cov_1ltzyrx9n4().s[0]++, {
  name: 'chevron-up-16',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.11612 10.8839C1.62796 10.3957 1.62796 9.60427 2.11612 9.11612L7.11612 4.11612C7.35054 3.8817 7.66848 3.75 8 3.75C8.33152 3.75 8.64946 3.88169 8.88388 4.11612L13.8839 9.11612C14.372 9.60427 14.372 10.3957 13.8839 10.8839C13.3957 11.372 12.6043 11.372 12.1161 10.8839L8 6.76777L3.88388 10.8839C3.39573 11.372 2.60427 11.372 2.11612 10.8839Z\" fill=\"currentColor\"/>"
});
export default Icon;